// Wrap the existing per-area card components as widgets in the universal
// registry. These are thin adapters: each pulls the matching `pick<T>()`
// shape out of `matter.workspace` and forwards it to the legacy card. The
// legacy components themselves stay untouched in their `asylum/` and
// `criminal/` subfolders.

import {
  pick,
  type BailShape,
  type COIShape,
  type ChargeShape,
  type CourtDateShape,
  type DeclarationShape,
  type I589Shape,
  type ImmigrationImpactShape,
} from "../workspace-shapes";
import { COICard } from "../asylum/COICard";
import { DeclarationCard } from "../asylum/DeclarationCard";
import { I589Card } from "../asylum/I589Card";
import { ChargesPanel } from "../criminal/ChargesPanel";
import { PleaStatus } from "../criminal/PleaStatus";
import { SentencingCard } from "../criminal/SentencingCard";
import type { WidgetProps } from "./types";

interface PleaShape {
  status?: string;
  offer?: string;
  counterOffer?: string;
  acceptedDate?: string;
}
interface SentencingShape {
  scheduled?: string;
  outcome?: string;
  guidelinesRange?: string;
  imposed?: string;
}

export function I589Widget({ matter }: WidgetProps) {
  const i589 = pick<I589Shape>(matter.workspace, "i589");
  return <I589Card i589={i589} />;
}

export function DeclarationWidget({ matter }: WidgetProps) {
  const declaration = pick<DeclarationShape>(matter.workspace, "declaration");
  return <DeclarationCard declaration={declaration} />;
}

export function COIWidget({ matter }: WidgetProps) {
  const coi = pick<COIShape>(matter.workspace, "coi");
  return <COICard coi={coi} />;
}

export function ChargesWidget({ matter }: WidgetProps) {
  const charges = pick<ChargeShape[]>(matter.workspace, "charges");
  return <ChargesPanel charges={charges} />;
}

export function PleaWidget({ matter }: WidgetProps) {
  const plea = pick<PleaShape>(matter.workspace, "plea");
  const bail = pick<BailShape>(matter.workspace, "bail");
  const impact = pick<ImmigrationImpactShape>(matter.workspace, "immigrationImpact");
  return <PleaStatus plea={plea} bail={bail} impact={impact} />;
}

export function SentencingWidget({ matter }: WidgetProps) {
  const sentencing = pick<SentencingShape>(matter.workspace, "sentencing");
  const courtDates = pick<CourtDateShape[]>(matter.workspace, "courtDates");
  return <SentencingCard sentencing={sentencing} courtDates={courtDates} />;
}
